export const test = {
  tabs: {
    frontend_list: {
      parts: ['MyPart'],
    },
  },
}
